/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {HandoverOfferDtoModel} from './handover-offer-dto.model';

export class RoutingSolutionViewModel extends JSONable {

  uuid: string | undefined = undefined;
  owner: string | undefined = undefined;
  parentOwner: string | undefined = undefined;
  offerRequestUuid: string | undefined = undefined;
  shipmentRequestUuid: string | undefined = undefined;
  shipmentGroupUuid: string | undefined = undefined;
  serviceProviderUuid: string | undefined = undefined;
  serviceProviderName: string | undefined = undefined;
  currency: string | undefined = undefined;
  costValue: string | undefined = undefined;
  details: string | undefined = undefined;
  pickupLocation: string | undefined = undefined;
  pickupDateTime: string | undefined = undefined;
  driverName: string | undefined = undefined;
  pickupTimezone: string | undefined = undefined;
  deliveryLocation: string | undefined = undefined;
  deliveryDateTime: string | undefined = undefined;
  deliveryTimezone: string | undefined = undefined;
  licensePlate: string | undefined = undefined;
  packagesNumber: string | undefined = undefined;
  transitDays: string | undefined = undefined;
  createdBy: string | undefined = undefined;
  originalOfferUuid: string | undefined = undefined;
  vehicleTypeValue: string | undefined = undefined;
  availableUntil: string | undefined = undefined;
  handoverOffers: HandoverOfferDtoModel[] | undefined = undefined;

  // frontend only
  selected: boolean | undefined = undefined;
}
